import { IconButton, Icons, Toggle, Tooltip } from '@silverfort/sf-components';
import { FC, SVGProps, useState } from 'react';
import CopyIcon from '../../../Controls/Buttons/CopyIcon';
import { SILVERFORT_API_FIELDS } from '../../common/fields';
import { UPDATE_ALLOW_EXTERNAL_RISK_API } from '../../containers/SilverfortApi/silverfortApiActions';

export const ExternalApi = ({ fields, dispatch, save }) => {
    const adminConsoleApiKey = fields[SILVERFORT_API_FIELDS.ADMIN_CONSOLE_API_KEY.ID];
    const allowExternalRiskApi = fields[SILVERFORT_API_FIELDS.ALLOW_EXTERNAL_RISK_API.ID];

    const [showExternalAPIKey, setShowExternalAPIKey] = useState(false);

    const toggleAllowExternalRiskApi = () => {
        dispatch({
            type: UPDATE_ALLOW_EXTERNAL_RISK_API,
            payload: {
                fieldId: allowExternalRiskApi.id,
                value: !allowExternalRiskApi.value
            }
        });
        save();
    };

    return (
        <div className="flex h-[40px] px-3 items-center border border-sf-gray-100 rounded-lg gap-6">
            {adminConsoleApiKey && (
                <div className="flex gap-3">
                    <div className="flex font-sf gap-2">
                        <div className="text-12 text-sf-gray-800 font-medium">External API key</div>
                        <input
                            readOnly
                            type={showExternalAPIKey ? 'text' : 'password'}
                            value={adminConsoleApiKey.value}
                            className="text-14 text-sf-gray-500 pointer-events-none"
                        />
                    </div>
                    <div className="flex text-sf-gray-400x gap-2 items-center">
                        <Tooltip title={showExternalAPIKey ? 'Hide' : 'Show'}>
                            <IconButton
                                className="flex items-center"
                                iconClassName="text-sf-gray-400"
                                icon={(showExternalAPIKey ? Icons.EyeOn : Icons.EyeOff) as FC<SVGProps<SVGSVGElement>>}
                                onClick={() => setShowExternalAPIKey((prevState) => !prevState)}
                            />
                        </Tooltip>
                        <CopyIcon value={adminConsoleApiKey.value} />
                    </div>
                </div>
            )}
            {allowExternalRiskApi && (
                <div className="flex gap-2 items-center">
                    <Toggle
                        className="m-0"
                        checked={allowExternalRiskApi?.value}
                        onChange={toggleAllowExternalRiskApi}></Toggle>
                    <div className="font-sf text-13 text-sf-gray-800">Allow access from public facing interface</div>
                </div>
            )}
        </div>
    );
};
